import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';

/**
 * Relationship classes
 */
export class PromoPageAttributes {
  slug: string;
  name: string;
  description: string;
}

export class PromoPageBelongsTo {}

export class PromoPageHasOne {}

export class PromoPageHasMany {}

/**
 * Utility interfaces
 */
export interface PromoPageMethods {}

export interface PromoPageInterface
  extends PromoPageAttributes,
    PromoPageBelongsTo,
    PromoPageHasOne,
    PromoPageHasMany,
    PromoPageType {}

type PromoPageType = GConstructor<PromoPageInterface>;

export interface PromoPageResource
  extends Base<PromoPageAttributes>,
    PromoPageInterface,
    PromoPageMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<PromoPageAttributes>({
    queryName: 'promo_pages',
    className: 'PromoPage',
    AttributesClass: PromoPageAttributes,
    BelongsToClasses: [
      {
        Klass: PromoPageBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: PromoPageHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: PromoPageHasMany,
      },
    ],
  });

export const PromoPageResourceClass = <TBase extends PromoPageType>(BaseConstructor: TBase) =>
  class extends BaseConstructor implements PromoPageMethods {};

export class PromoPageResource extends ClassExtender<PromoPageInterface>(
  BaseClass,
  PromoPageResourceClass,
) {}

/**
 * Resource instance
 */
export const PromoPage = APILibrary.createResource<PromoPageResource>(PromoPageResource);
